import { render, staticRenderFns } from "./returnFix.vue?vue&type=template&id=a11f82c2&scoped=true"
import script from "./returnFix.vue?vue&type=script&lang=js"
export * from "./returnFix.vue?vue&type=script&lang=js"
import style0 from "./returnFix.vue?vue&type=style&index=0&id=a11f82c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11f82c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a11f82c2')) {
      api.createRecord('a11f82c2', component.options)
    } else {
      api.reload('a11f82c2', component.options)
    }
    module.hot.accept("./returnFix.vue?vue&type=template&id=a11f82c2&scoped=true", function () {
      api.rerender('a11f82c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/returned/returnFix.vue"
export default component.exports